module.exports = __webpack_public_path__ + "img/Frame 1066four.877e2b33.png";